import styled, { css } from 'styled-components';

import { Button } from '../button';

type DayOfWeekButtonProps = {
  $active: boolean;
};

const activeStyles = css`
  background: var(--color-grayscale-black);
  color: var(--color-grayscale-white);
  :hover {
    background: var(--color-gray-90);
  }
`;

const inactiveStyles = css`
  background: var(--color-gray-20);
  color: var(--color-grayscale-black);
  :hover {
    background: var(--color-gray-40);
  }
`;

export const StyledDayOfWeekButton = styled(Button)<DayOfWeekButtonProps>`
  :focus {
    outline: 1px solid var(--color-grayscale-black);
  }
  min-width: 54px;
  padding: var(--sizes-30);
  ${({ $active }) => $active && activeStyles}
  ${({ $active }) => !$active && inactiveStyles}
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  gap: var(--sizes-40);
`;

export const PickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-20);
  > label {
    align-self: flex-start;
  }
`;
